module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-eofy-mobile.de10d5f6.png";